import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu způsobů platby.
 */
class ZpusobPlatbyForm extends Component<WithTranslation> {

    static formName = 'ZpusobPlatbyForm';

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.code')} name="kodZpusobPlatba" required disabled={submitting}/>
                <ff.String label={t('labels.name')} name="nazevZpusobPlatba" required disabled={submitting}/>
                <CustomCheckboxField label={t('cash')} name="hotovost" disabled={submitting}/>
                <CustomCheckboxField label={t('allow_without_company')} name="povolitBezSpolecnosti" disabled={submitting}/>
                <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: ZpusobPlatbyForm.formName,
})(ZpusobPlatbyForm)));
